import type { GanttData } from '../types';

export const getUnresolvedDependenciesMap = (data: GanttData): Map<string, boolean> => {
  const map = new Map<string, boolean>();
  
  // Initialize all tasks to false
  data.tasks?.forEach(task => map.set(task.id, false));

  // Build a quick lookup for task resolution status
  const isTaskResolved = new Map(data.tasks?.map(t => [t.id, t.isResolved === true]));

  // Check dependencies
  data.dependencies?.forEach(dep => {
    // If the dependency comes from a task that is NOT resolved
    if (isTaskResolved.has(dep.fromTaskId) && !isTaskResolved.get(dep.fromTaskId)) {
      // Mark the target task as having an unresolved dependency
      map.set(dep.toTaskId, true);
    }
  });

  return map;
};
